import { takeLatest, put, call } from 'redux-saga/effects';
import swal from 'sweetalert';

import { history } from '@commons';

import { deleteMotoristaCadastro } from '../service';
import {
  DELETE_MOTORISTA_CADASTRO,
  DELETE_MOTORISTA_CADASTRO_PENDING,
  DELETE_MOTORISTA_CADASTRO_SUCCESS,
  DELETE_MOTORISTA_CADASTRO_FAILURE,
} from '../actionTypes';

import { AlertError } from '@components/common/AlertToast'
import { trackingEventCX, MODULE_ACTIONS_ENUM } from '@handler/tracking/customerX';

function* sagaDeleteMotoristaCadastro(action) {
  yield put({ type: DELETE_MOTORISTA_CADASTRO_PENDING, id: action.id })

  trackingEventCX('action', MODULE_ACTIONS_ENUM.MOTORISTA_EXCLUIR);

  try {
    const a = yield call(deleteMotoristaCadastro, action.id);

    if (a.status !== 204) {
      throw new Error('API delete request failed');
    }
    yield put({ type: DELETE_MOTORISTA_CADASTRO_SUCCESS, id: action.id });

    swal({
      title: 'Excluído!',
      icon: 'success',
      buttons: {
        cancel: false,
        confirm: {
          text: 'OK',
          value: true,
          visible: true,
          className: 'btn-primary',
          closeModal: true
        }
      }
    }).then(() => {
      history.go(0)
    });

  } catch (error) {

    yield put({ type: DELETE_MOTORISTA_CADASTRO_FAILURE });

    AlertError('Falha ao excluir o registro! Tente novamente...');
  }
}

export default function* watchDeleteMotoristaCadastro() {
  yield takeLatest(DELETE_MOTORISTA_CADASTRO, sagaDeleteMotoristaCadastro)
}
